import CarouselDisplayTrigger from '@alltrails/amplitude/enums/CarouselDisplayTrigger';
import InstallPromptLocation from '@alltrails/amplitude/enums/InstallPromptLocation';
import InstallPromptSource from '@alltrails/amplitude/enums/InstallPromptSource';
import InstallPromptType from '@alltrails/amplitude/enums/InstallPromptType';
import logInstallPromptClicked from '@alltrails/amplitude/events/logInstallPromptClicked';

export const iosAppStoreUrl = 'https://apps.apple.com/us/app/alltrails-hike-bike-run/id405075943';
export const androidAppStoreUrl = 'https://play.google.com/store/apps/details?id=com.alltrails.alltrails';

export const deepLinkRedirect = (
  deeplink: string,
  promptType: InstallPromptType,
  promptLocation: InstallPromptLocation,
  promptSource: InstallPromptSource,
  displayTrigger?: CarouselDisplayTrigger
) => {
  logInstallPromptClicked({
    install_prompt_type: promptType,
    install_prompt_location: promptLocation,
    install_prompt_source: promptSource,
    signup_modal_trigger: displayTrigger
  });

  window.location.assign(deeplink);
};
